import { BaseModel } from '../base-model';
import { IGenericObject } from '../common';
import ItemStateStatus from '../../common/item-state.constant';
export interface IPropertyRoomModel {
  PropertyId?: number;
  FloorId?: number;
  DescriptionId?: number;
  Description?: string;
  Width?: number;
  Length?: number;
  Area?: number;
  StateId?: number;
  ItemState?: number;
  FloorCoveringId?: number;
  StateInfo?: IGenericObject;
  FloorInfo?: IGenericObject;
  DescriptionInfo?: IGenericObject;
  FloorCoveringInfo?: IGenericObject;
  CommentsNL?: string;
  CommentsFR?: string;
  CommentsSP?: string;
  CommentsCA?: string;
  CommentsEN?: string;
  CommentsDE?: string;
  Income?: number;
  PotIncome?: number;
  OrderNr?: number;
  Coefficient?: number;
  SurfaceAfterCF?: number;
  Id?: number;
  getFloorInfo?: any;
  getStateInfo?: any;
  getDescriptionInfo?: any;
    getFloorCoveringInfo?: any;
    TempId?: number;
}
export class PropertyRoomModel extends BaseModel<IPropertyRoomModel> implements IPropertyRoomModel {

  StateInfo?: IGenericObject;
  FloorInfo?: IGenericObject;
  DescriptionInfo?: IGenericObject;
  FloorCoveringInfo?: IGenericObject;

  getDescriptionInfo(source: IGenericObject[]) {
    if (this.DescriptionId !== undefined)
      return this.DescriptionInfo = source.find(desc => desc.Id === this.DescriptionId);
    return {};
  }
  getStateInfo(source: IGenericObject[]) {
    if (this.StateId !== undefined)
      return this.StateInfo = source.find(state => state.Id === this.StateId);
    return {};
  }
  getFloorInfo(source: IGenericObject[]) {
    if (this.FloorId !== undefined)
      return this.FloorInfo = source.find(floor => floor.Id === this.FloorId);
    return {};
  }
  getFloorCoveringInfo(source: IGenericObject[]) {
    if (this.FloorCoveringId !== undefined)
      return this.FloorCoveringInfo = source.find(floorCovering => floorCovering.Id === this.FloorCoveringId);
    return {};
  }


  Width: number;
  Length: number;
  Area: number = null;
  PropertyId?: number;
  FloorId?: number;
  DescriptionId?: number;
  ItemState?: number;
  StateId?: number;
  FloorCoveringId?: number;
  CommentsNL?: string;
  CommentsFR?: string;
  CommentsSP?: string;
  CommentsCA?: string;
  CommentsEN?: string;
  CommentsDE?: string;
  Income?: number;
  PotIncome?: number;
  OrderNr?: number;
  Coefficient?: number;
  SurfaceAfterCF?: number;
    Id?: number;
    TempId?: number;
  /**
   *
   */
  constructor(option?: IPropertyRoomModel) {
    super(option)
    this.ItemState = ItemStateStatus.Added;
  }
}